import { ReactElement } from 'react';

import StipulatorContext from '@philips-emr/hpms-stipulator-commons/lib/contexts/stipulator-context';
import FilterService from '@philips-emr/hpms-stipulator-commons/lib/services/filter-service';
import {  FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnBeforeFetch, OnDynamicContentRender, OnMount, OnUnmount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { ConsultaAlteracaoVinculoAliases as Aliases, FragmentNames } from '../codegen';

import BaseController from './BaseController';
import { getLoteStampBySituacao, LoteSituacao } from './lote/lote-utils';

enum SituacaoVinculo {
  APROVADO = 1,
  REJEITADO = 2,
  PENDENTE = 3,
}

interface Data {
  dsSituacao: string;
  ieSituacao: SituacaoVinculo;
}

@Controller({ fragment: FragmentNames.CONSULTA_ALTERACAO_VINCULO })
class ConsultarAlteracoesVinculoController extends BaseController {

  @OnMount(Aliases.FILTER_CONSULTA)
  onFilterMount(event: MountEvent): void {
    FilterService.restoreFilterState(event);
  }

  @OnUnmount(Aliases.FILTER_CONSULTA)
  onUnmountFilter(event: MountEvent): void {
    FilterService.persistFilterState(event);
  }

  @OnDynamicContentRender(Aliases.RENDER_STATUS)
  onDynamicContentRenderCardLote(event: RenderEvent): void {
    const { data, render } = event;
    const { dsSituacao, ieSituacao } = data as Data;
    
    const situacaoMap = {
      [SituacaoVinculo.APROVADO]: LoteSituacao.INTEGRADO_A_PROPOSTA,
      [SituacaoVinculo.PENDENTE]: LoteSituacao.AGUARDANDO_ACAO_DO_USUARIO,
      [SituacaoVinculo.REJEITADO]: LoteSituacao.REJEITADA_PELA_OPERADORA,
    };

    const content = (): ReactElement => (getLoteStampBySituacao(situacaoMap[ieSituacao], dsSituacao));

    render(content);
  }

  @OnBeforeFetch(Aliases.FETCH_CONSULTA)
  onBeforeFetchBeneficiarios(event: MountEvent): void {
    const fetch = event.target as unknown as FetchAPI;
    const { nrSeqSubestipulante } = StipulatorContext.getCurrentContract();
    nrSeqSubestipulante && fetch.setParameters({ ...fetch.getParameters(), nrSeqSubestipulante });
  }

}
export default ConsultarAlteracoesVinculoController;
